import type { FpFile } from "../../../../../schemas/codegen";
import { useMessageStore } from "../../../../state/stores";
import { MarkdownAttachment } from "./MarkdownAttachment";
import { OtherAttachments } from "./OtherAttachments";

interface AttachmentsProps {
  messageId: string;
}

const EMPTY_ARRAY: FpFile[] = [];

export function Attachments({ messageId }: AttachmentsProps) {
  const messages = useMessageStore((state) => state.messages);

  // Find the message and extract spec and version files directly
  const message = messages.find((m) => m.id === messageId);
  const spec = message?.spec;
  const version = message?.version;
  const files = version?.files ?? EMPTY_ARRAY;

  return (
    <>
      {/* Render spec first (it's the primary document) */}
      {spec && <MarkdownAttachment key={spec.id} attachment={spec} />}

      {/* Render other files */}
      {files.length > 0 && version?.version !== undefined && (
        <OtherAttachments attachments={files} versionNumber={version.version} />
      )}
    </>
  );
}
